'use client';

import { BetterTooltip } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { copyToClipboard } from '@/utils/clipboard';

type PrV2CopyNumberButtonProps = {
  number: number | string;
  className?: string;
  numberTextId?: string;
};

export function PrV2CopyNumberButton({
  number,
  className,
  numberTextId,
}: PrV2CopyNumberButtonProps) {
  const onCopy = () => {
    void copyToClipboard(String(number), {
      successMessage: 'PR number copied',
      errorMessage: 'Failed to copy PR number',
    });
  };

  return (
    <BetterTooltip content="Copy PR number">
      <button
        type="button"
        onClick={onCopy}
        className={cn('shrink-0 focus-visible:outline-none focus-visible:underline', className)}
        aria-label={`Copy pull request number ${number}`}
      >
        <span id={numberTextId}>{`#${number}`}</span>
      </button>
    </BetterTooltip>
  );
}
